import { createSelector } from 'reselect';

import find from 'lodash/find';
import _isEmpty from 'lodash/isEmpty';

import { getOpenedFiles } from 'store/utils/fileSystem';

const testSetsSelector = state => state.testSets;

export const showSelector = createSelector(
  testSetsSelector,
  testSets => testSets.show,
);

export const getAllFiles = createSelector(
  testSetsSelector,
  testSets => testSets.all.data,
);

export const getFiles = ({ testSets }) => testSets.all.data;

export const getCount = ({ testSets }) => testSets.all.count;

export const getCurrentPage = ({ testSets }) => testSets.all.currentPage;

export const getFilesMap = createSelector(getFiles, data =>
  data.reduce(
    (acc, item) => ({
      ...acc,
      [item.id]: item,
    }),
    {},
  ),
);

export const getSearchTerm = ({ testSets }) => testSets.all.searchTerm;

export const getIsLoading = ({ testSets }) => testSets.all.isLoading;

export const getIsUploading = ({ testSets }) => testSets.upload.isLoading;

export const getUploadingFiles = ({ testSets }) => testSets.upload.files;

export const getIsSaving = ({ testSets }) => testSets.show.isSaving;

export const getUploadingFilesWithError = createSelector(
  getUploadingFiles,
  files => files.filter(f => f.hasError === true),
);

export const getHasUploadingFilesError = createSelector(
  getUploadingFilesWithError,
  files => files.length !== 0,
);

export const getFilteredFiles = createSelector(
  getFiles,
  getSearchTerm,
  (files, searchTerm) =>
    files.filter(f => f.name.toLowerCase().includes(searchTerm.toLowerCase())),
);

export const getEditorFiles = createSelector(getFiles, all =>
  getOpenedFiles(all),
);

export const getEditorCurrentFile = createSelector(
  showSelector,
  getAllFiles,
  (show, all) => find(all, { id: show.presentedId }) || {},
);

export const getEditorSearchTerm = ({ testSets }) => testSets.show.searchTerm;

export const getTheme = ({ testSets }) => testSets.show.theme;

export const getIsEditorLoading = ({ testSets }) => testSets.show.isLoading;

export const getTestSetsList = ({ testSets }) => testSets.list.data.items;

export const getTestSetsListCount = ({ testSets }) => testSets.list.data.count;

export const getTestSet = ({ testSets }) => testSets.open.data;

export const getHasSelectedTestSet = createSelector(
  getTestSet,
  testSet => !_isEmpty(testSet),
);

export const getIsLoadingList = ({ testSets }) => testSets.list.isLoading;

export const getPaginationOptions = ({ testSets }) =>
  testSets.list.paginationOptions;
